let nextIdIndex = 1;
export const nextId = () => 'bf-' + nextIdIndex++;
